import { CloseOutlined, FullscreenOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { useAppSelector } from '@/hooks'
import { getSixLawsImageUrl } from '@/assets/images/SixLawsPage/imageMap'

const WeizhiThumbnail = (props) => {
  const globalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)

  const globalTagTree = useAppSelector((state) => state.sixLawsInfo.globalTagTree)
  // console.log(globalTagTree,"globalTagTree");

  const setShowPanel = props.setShowPanel
  const [currentTags, setCurrentTags] = useState<string[]>([])
  const [currentImgSrc, setCurrentImgSrc] = useState<string>('')

  //设置当前画作的构图tags
  useEffect(() => {
    setCurrentTags(globalTags.构图)
    if (globalTags.构图.length > 0) {
      const goutuInfo = globalTagTree.构图.filter((item) => item.title === globalTags.构图[0])
      if (goutuInfo.length > 0) {
        setCurrentImgSrc(goutuInfo[0].imgSrc ?? '')
      }
    } else {
      setCurrentImgSrc('')
    }
  }, [globalTagTree.构图, globalTags.构图])

  return (
    <div className='weizhi-thumbnail-panel'>
      <div className='weizhi-thumbnail-title'>
        <h2>经营位置</h2>
        <FullscreenOutlined
          className='weizhi-thumbnail-button'
          onClick={() => {
            setShowPanel(2)
          }}
        />
      </div>
      <div className='weizhi-thumbnail-tags'>
        {currentTags.map((item) => {
          return (
            <div className='editableTag' key={item}>
              <div className='editableTag-title'>{item}</div>
              <button
                className='editableTag-delete'
                onClick={() => {
                  const newCurrentTags = currentTags.filter((i) => i !== item)
                  setCurrentTags(newCurrentTags)
                }}
              >
                <CloseOutlined className='editableTag-cross' />
              </button>
            </div>
          )
        })}
      </div>
      {currentImgSrc.length > 0 ? (
        <img src={getSixLawsImageUrl(currentImgSrc)} alt='' className='weizhi-thumbnail-img' />
      ) : null}
    </div>
  )
}

export default WeizhiThumbnail
